import { API_BASE } from "./api";

/**
 * Resolve an image path (data URL, external http URL, or internal /api/media/{id})
 * to a full src that works from the frontend origin.
 */
export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${API_BASE.replace(/\/api$/, "")}${url}`;
  return url;
}
